export default function CryptoActive({ width = 14, height = 24, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 24"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M0 13.2021L6.9989 23.2233L13.9978 13.2021L6.9989 17.4174L0 13.2021Z"
                fill="#EAEAEA"
            />
            <path
                d="M14 11.7707L7.0011 -0.00016342L0.00219594 11.7707L7.0011 16.0654L14 11.7707Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
